import pfpArtBySd from "assets/images/pfp-art-by-sd.jpg";
import pfpChrisYang from "assets/images/pfp-chris-yang.jpg";
import pfpGrymm from "assets/images/pfp-grymm.jpg";
import pfpRebeccaSire from "assets/images/pfp-rebecca-sire.jpg";
import pfpSaraBauman from "assets/images/pfp-sara-bauman.jpg";
import pfpTeflon from "assets/images/pfp-teflon.jpg";
import slide1 from "assets/images/slide1-art.png";
import slide1Sm from "assets/images/slide1-art-sm.png";
import slide2 from "assets/images/slide2-photography.png";
import slide2Sm from "assets/images/slide2-photography-sm.png";
import slide3 from "assets/images/slide3-paintings.png";
import slide3Sm from "assets/images/slide3-paintings-sm.png";
import slide4 from "assets/images/slide4-ceramics.png";
import slide4Sm from "assets/images/slide4-ceramics-sm.png";
import slide5 from "assets/images/slide5-tattoos.png";
import slide5Sm from "assets/images/slide5-tattoos-sm.png";
import slide6 from "assets/images/slide6-anything.png";
import slide6Sm from "assets/images/slide6-anything-sm.png";

type LoggedOutSlide = {
  text: string;
  imgLg: string;
  imgSm: string;
};

const slides: LoggedOutSlide[] = [
  {
    text: "Your Art",
    imgLg: slide1,
    imgSm: slide1Sm,
  },
  {
    text: "Your Photography",
    imgLg: slide2,
    imgSm: slide2Sm,
  },
  {
    text: "Your Paintings",
    imgLg: slide3,
    imgSm: slide3Sm,
  },
  {
    text: "Your Ceramics",
    imgLg: slide4,
    imgSm: slide4Sm,
  },
  {
    text: "Your Tattoos",
    imgLg: slide5,
    imgSm: slide5Sm,
  },
  {
    text: "Anything You Create",
    imgLg: slide6,
    imgSm: slide6Sm,
  },
];

type Testimonial = {
  name: string;
  artistId: string;
  pfp: string;
  quote: string;
};

const testimonials: Testimonial[] = [
  {
    name: "Teflon",
    artistId: "teflon",
    pfp: pfpTeflon,
    quote:
      "All the creative folks are on HUG! One of the few platforms out there solving the main challenge for emerging artists: discoverability.",
  },
  {
    name: "Sara Bauman",
    artistId: "sara-baumann",
    pfp: pfpSaraBauman,
    quote:
      "Awesome to see all the open calls being provided through HUG. Cannot express how appreciative I am for these opportunities, not just for myself, but for all artists!",
  },
  {
    name: "Chris Yang",
    artistId: "chrisyang",
    pfp: pfpChrisYang,
    quote:
      "HUG is a platform that not only brings artists and art lovers together, but also genuinely contributes to the entire art community.",
  },
  {
    name: "Art by SD",
    artistId: "CreatedbySD",
    pfp: pfpArtBySd,
    quote:
      "Grateful for the opportunity to share my art with the world! Thank you HUG, truly one of the happiest moments of my life.",
  },
  {
    name: "Grymm",
    artistId: "grymm",
    pfp: pfpGrymm,
    quote:
      "The fact that HUG genuinely wants to support us creatives and help us grow, has made this community so special to me. Thank you for helping me grow my confidence.",
  },
  {
    name: "Rebecca Sira",
    artistId: "rebeccasiraart",
    pfp: pfpRebeccaSire,
    quote:
      "HUG is a community that I'm really proud to be a part of. Everyone is really friendly and accessible, which I really appreciate, as the art world can be super daunting!",
  },
];

type ArtistInfo = {
  name: string;
  artistId: string;
  tag?: string;
};

const artists: ArtistInfo[] = [
  // Slide 1
  {
    name: "Alanna Wilcox",
    artistId: "alanna_wilcox",
  },
  {
    name: "Jaime Derringer",
    artistId: "jaime_derringer",
  },
  {
    name: "Balloonski",
    artistId: "balloonski",
  },
  {
    name: "AngieFreeDiver",
    artistId: "angiefreediver",
  },
  {
    name: "1dontknows",
    artistId: "1dontknows",
  },
  {
    name: "Sour Power",
    artistId: "sourpower",
  },
  {
    name: "VEL LY",
    artistId: "vel_ly",
  },
  {
    name: "VincentGhoste",
    artistId: "VincentGhoste",
  },
  {
    name: "Moonlight Media",
    artistId: "moonlight-media",
  },
  // Slide 2
  {
    name: "Tylersjourney",
    artistId: "tylersjourney",
  },
  {
    name: "Ada Crow",
    artistId: "adacrow",
  },
  {
    name: "Choen Lee",
    artistId: "choen_lee",
  },
  {
    name: "Leslie A Spurlock",
    artistId: "leslie_a_spurlock",
  },
  {
    name: "Toni Traglia",
    artistId: "ToniTraglia",
  },
  {
    name: "Dan Woo",
    artistId: "dan-woo",
  },
  {
    name: "deftony",
    artistId: "deftony",
  },
  {
    name: "Sherie Margaret Ngigi",
    artistId: "sherie_margaret_ngigi",
  },
  {
    name: "Immigrant Daughter",
    artistId: "immigrant_daughter",
  },
  // Slide 3
  {
    name: "Cinthia Ponce",
    artistId: "cinthia_ponce",
  },
  {
    name: "Sabet",
    artistId: "sabet",
  },
  {
    name: "Pax Paints",
    artistId: "paxpaints",
  },
  {
    name: "Seungdo Hyun",
    artistId: "seungdo-hyun",
  },
  {
    name: "OYA",
    artistId: "oya_zen",
  },
  {
    name: "Michiko",
    artistId: "marodori",
  },
  {
    name: "Sasha Mihajlovic",
    artistId: "sashapaintings",
  },
  {
    name: "Montalut",
    artistId: "montalut",
  },
  {
    name: "Ikal Laki",
    artistId: "ikallaki",
  },
  // Slide 4
  {
    name: "AfricanArtNFTS",
    artistId: "AfricanArtNFTs",
  },
  {
    name: "Jacopo Truffa",
    artistId: "jcptrf",
  },
  {
    name: "Aleksys",
    artistId: "aleksys",
  },
  {
    name: "Paula Greif",
    artistId: "paulagreifceramics",
  },
  {
    name: "Irina Razumovskaya",
    artistId: "irinaraz",
  },
  {
    name: "Hannah Tounsend",
    artistId: "hannah_tounsend",
  },
  {
    name: "Noelia Lozano",
    artistId: "noelialozano",
  },
  {
    name: "Nathaniel Stern",
    artistId: "nathanielstern",
  },
  {
    name: "Eglė Einikyte-Narkevičienė",
    artistId: "einikytenarkeviciene",
  },
  // Slide 5
  {
    name: "Tattoofingers",
    artistId: "Tat2",
  },
  {
    name: "Adricci",
    artistId: "adrianhc",
  },
  {
    name: "Clare Von Savage",
    artistId: "clare_von_savage",
  },
  {
    name: "Vickilicious Designs Cute & Creepy",
    artistId: "Vickilicious10",
  },
  {
    name: "elrokk",
    artistId: "elrokk",
  },
  {
    name: "Lauren YS",
    artistId: "laurenys",
  },
  {
    name: "gayfamous",
    artistId: "artgayfamousistID",
  },
  {
    name: "E1even_xi",
    artistId: "e1even_xi",
  },
  // Slide 6
  {
    name: "Yolantis",
    artistId: "yolantis",
  },
  {
    name: "Adelia",
    artistId: "adelia",
  },
  {
    name: "Pablo Espinoza",
    artistId: "PabloEspinoza",
  },
  {
    name: "Adiw",
    artistId: "adiw",
  },
  {
    name: "Matteo Campulla",
    artistId: "matteocampulla",
  },
  {
    name: "Angad",
    artistId: "angadbsodhi",
  },
  {
    name: "Lasith Fernando",
    artistId: "lasithmfernando",
  },
  {
    name: "Su Postill",
    artistId: "su-postill",
  },
];

export { slides, testimonials, artists };
